import { isFirefox } from '@resn/gozer-env';
import { TextureLoader, Texture, ImageBitmapLoader, Math, VideoTexture } from 'three';

import TickerService from '@resn/gozer-services/ticker-service';

import Renderer from 'component/gl/renderer';

// const supportsImageBitmap = typeof createImageBitmap !== 'undefined';
// const supportsImageBitmap = !isFirefox && typeof createImageBitmap !== 'undefined';
const supportsImageBitmap = false;

const loader = supportsImageBitmap ? new ImageBitmapLoader() : new TextureLoader();

if (supportsImageBitmap) {
    loader.setOptions({ imageOrientation: 'flipY' });
}

const TextureCache = new Map();

const pushingQueue = [];

const queue = (d, done) => {
    pushingQueue.push({ d, done });
};

const checkQueue = () => {
    if (pushingQueue.length) {
        const { d, done } = pushingQueue.pop();
        const renderer = Renderer.getRenderer();

        renderer.initTexture(d);
        done();
    }
};

TickerService.add(checkQueue);

export default function loadTexture(url) {
    return new Promise((resolve) => {
        const data = TextureCache.get(url);

        if (data) {
            // console.log('TextureCache - read from cache:', url);
            resolve(data);
        } else {
            if (url.match(/\.mp4#txt$/gm)) {
                // load as a video instead

                // fetch entire video as blob first to ensure
                // it is fully loaded
                fetch(url)
                    .then((r) => r.blob())
                    .then((blob) => {
                        const video = document.createElement('video');
                        video.muted = true;
                        video.playsInline = true;
                        video.src = URL.createObjectURL(blob);

                        const texture = new VideoTexture(video);
                        queue(texture, () => {
                            resolve(texture);
                        });
                    });
            } else {
                loader.load(
                    url,
                    (val) => {
                        // set options if needed
                        const image = supportsImageBitmap ? val : val.image;
                        const texture = supportsImageBitmap ? new Texture(val) : val;

                        if (!Math.isPowerOfTwo(image.width) || !Math.isPowerOfTwo(image.height)) {
                            if (__ENV__ === 'local' || __ENV__ === 'development') {
                                console.warn(`>>> "${url}" image size is not power of 2 <<<`);
                            }
                        }

                        // texture.needsUpdate = true;
                        queue(texture, () => {
                            resolve(texture);
                        });
                        TextureCache.set(url, texture);
                    },
                    null,
                    (err) => {
                        console.log('err', err);
                    },
                );
            }
        }
    });
}
